function Narrator(stage) {
    this.stage = stage;

    this.setDefaultOptions = function() {

    }
}

Narrator.prototype.post =
    function (msg) {
        document.getElementById('narrative').innerHTML = msg;
    };
